import { SystemDataService } from './service/data/system-data.service';
import { BasicAuthenticationService } from './auth/basic-authentication.service';
import { HttpIntercepterBasicAuthService } from './service/http/http-intercepter-basic-auth.service';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { CalendarModule, DateAdapter, MOMENT } from 'angular-calendar';

import {
  MatButtonModule,
  MatMenuModule,
  MatToolbarModule,
  MatIconModule,
  MatCardModule,
  MatFormFieldModule
} from '@angular/material';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AuthGuard } from './auth/auth.guard';
//import { AuthService } from './auth/auth.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { DeceasedProfileComponent } from './deceased-profile/deceased-profile.component';
import { BookAppointmentComponent } from './book-appointment/book-appointment.component';
import { BookHistoryComponent } from './book-history/book-history.component';
import { MyDetailsComponent } from './my-details/my-details.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MaintenanceComponent } from './maintenance/maintenance.component';

import { CommonModule, DatePipe } from '@angular/common';
import { FlatpickrModule } from 'angularx-flatpickr';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';


@NgModule({
  declarations: [
    AppComponent,
    LoginFormComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    DeceasedProfileComponent,
    BookAppointmentComponent,
    BookHistoryComponent,
    MyDetailsComponent,
    MaintenanceComponent,
    ForgotPasswordComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    MatButtonModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    BrowserAnimationsModule,
    NgxQRCodeModule,
    MatTableModule,
    MatCheckboxModule,
    HttpClientModule,
    CommonModule,
    NgbModalModule,
    FlatpickrModule.forRoot(),
    CalendarModule.forRoot({ provide: DateAdapter, useFactory: adapterFactory }),
  ],
  providers: [
    AuthGuard,
    { provide: HTTP_INTERCEPTORS, useClass: HttpIntercepterBasicAuthService, multi: true },
    BasicAuthenticationService,
    SystemDataService,
    DatePipe
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
